import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const FingerPrintContext = createContext(null);
export const FingerPrintProvider = ({ value, children }) => {
    return _jsx(FingerPrintContext.Provider, { value: value, children: children });
};
export default FingerPrintProvider;
